import { render } from "./productProfitReport.vue?vue&type=template&id=18189f13&scoped=true"
import script from "./productProfitReport.vue?vue&type=script&lang=js"
export * from "./productProfitReport.vue?vue&type=script&lang=js"

import "./productProfitReport.vue?vue&type=style&index=0&id=18189f13&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18189f13"]])

export default __exports__